export default __webpack_public_path__ + "nlp43036f.png";